import { Route } from '@angular/router';
import { AboutComponent } from './pages/about/about.component';
import { ArticleDetailComponent } from './pages/article-detail/article-detail.component';
import { HomeComponent } from './pages/home/home.component';
import { McpClientsComponent } from './pages/mcp-clients/mcp-clients.component';
import { McpServersComponent } from './pages/mcp-servers/mcp-servers.component';
import { NewsComponent } from './pages/news/news.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';

export const appRoutes: Route[] = [
  { path: '', component: HomeComponent },
  { path: 'news', component: NewsComponent },
  { path: 'news/:slug', component: ArticleDetailComponent },
  { path: 'about', component: AboutComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'subscribe', component: SubscribeComponent },
  { path: 'mcp-servers', component: McpServersComponent },
  { path: 'mcp-clients', component: McpClientsComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent },
];
